"use client"; // Los error boundaries deben ser Client Components.

import { useEffect } from "react";

import { reportClientError } from "@/core/observability/client-report";

// global-error reemplaza al root layout cuando el propio layout raíz
// crashea (caso raro y fatal). Debe traer sus PROPIOS <html>/<body> y no
// puede depender del CSS del template (el layout que lo importa fue
// reemplazado), así que va con estilos inline.
//
// Es el último recurso: reportamos SIEMPRE (force) con severity 'fatal',
// aunque el error tenga digest, porque que el root se rompa es algo que
// queremos saber sí o sí.
export default function GlobalError({
  error,
  reset,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  reset?: () => void;
  unstable_retry?: () => void;
}) {
  useEffect(() => {
    reportClientError({
      error,
      context: `global-error${error.digest ? `:${error.digest}` : ""}`,
      severity: "fatal",
      force: true,
    });
  }, [error]);

  const retry = unstable_retry ?? reset;

  return (
    <html lang="es-AR">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily:
            "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
          background: "#fafafa",
          color: "#18181b",
        }}
      >
        <title>Algo salió mal · Sesionia</title>
        <div style={{ maxWidth: 360, padding: 24, textAlign: "center" }}>
          <h1 style={{ fontSize: 18, fontWeight: 600, margin: "0 0 8px" }}>
            Algo salió mal
          </h1>
          <p style={{ fontSize: 14, color: "#71717a", margin: "0 0 20px" }}>
            Tuvimos un problema inesperado. Ya lo registramos. Podés reintentar.
          </p>
          <button
            type="button"
            onClick={() => retry?.()}
            style={{
              fontSize: 14,
              fontWeight: 500,
              padding: "8px 16px",
              borderRadius: 8,
              border: "1px solid #e4e4e7",
              background: "#fff",
              cursor: "pointer",
            }}
          >
            Reintentar
          </button>
        </div>
      </body>
    </html>
  );
}
